import React from 'react';
import performanceStore from '../../stores/performance';

function Countdown(props) {

  const nextPerformance = performanceStore((state) => state.nextPerformance);
  const countdown = performanceStore((state) => state.countdown);

  const countdownStr = () => { 
    if (nextPerformance) {
      if (nextPerformance.unique_id === props.performance.unique_id) {
        return countdown + " s - ";
      }
    }
    return "";
  };

  return (
    <span>
      {countdownStr()}
    </span>
  );

}

export default Countdown;
